import {UserSettingsTypeDataInterface} from "../../dataInterface/userSettingsTypeDataInterface";


interface type {
    type:string
    payload:UserSettingsTypeDataInterface
}

export default (state = null, action:type) => {
    switch (action.type) {
        case "GET_TYPE_SETTINGS":
            return action.payload;
        default:
            return state;
    }
};
